module.exports = __webpack_public_path__ + "img/bo.fd88dfab.png";